import { useEffect, useState } from 'react';
import { useAuth } from '../auth/authentication/hooks/useAuth';
import { growthbook } from '../integrations/growthbook';

export function useGrowthbookUserInit() {
  const auth = useAuth();
  const [gbReady, setGbReady] = useState(false);

  useEffect(() => {
    if (!auth.user) {
      setGbReady(true);
      return;
    }

    growthbook.setAttributes({
      id: auth.user.id,
      email: auth.user.email,
      client: auth.client?.slug,
    });

    growthbook.refreshFeatures().finally(() => {
      setGbReady(true);
    });
  }, [auth.user]);

  return gbReady;
}
